export default "__VITE_ASSET__c20dcad5__"